import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ChangeLogEntry  {
    _originalTypeClassName = "zAppDevManager.BO.ChangeLogEntry";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ChangeLogEntry.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Vesrion = null;
this.Changes = null;
this.Project = null;
this.ReleaseDate = null;
this.VersionAsNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Vesrion:any;
Changes:any;
Project:any;
ReleaseDate:any;
VersionAsNumber:any;

static VersionToNumner(version: any): any{let base = 1;
let items = System.split(version, '.');
while (CLMS.Framework.Number.LessThan(() => items.length, () => 4)) {items?.add("0");}
let number = "";
for (var i = 0; CLMS.Framework.Number.LessThan(() => i, () => items.length); i = Joove.Common.safeNumber(i) + Joove.Common.safeNumber(1)) {
let item = items[i];number = number + CLMS.Framework.String.FillWith('0', Joove.Common.safeNumber(4) - Joove.Common.safeNumber(item?.length)) + item;}

return CLMS.Framework.Long.Parse(number);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}